export const errorCss = errorField => errorField ? "is-invalid" : "is-valid";

export const getValue = target => {

    switch (target.type) { 
        case 'checkbox':
            return target.checked;
        default:
        return target.value;
    }
}

export const hasError = formik => {
    return Object.keys(formik.errors).length !== 0
}

export const displayErrors = formik => {

    if (!hasError(formik)) {
        return <></>
    }

    return <div className="text-danger">{Object.values(formik.errors).map(x => <div>{x}</div>)}</div>
}